// extracted by mini-css-extract-plugin
module.exports = {"title":"Gov_title__LXFQ2"};